import React, { FC } from "react";
import { COLORS } from "../../common/consts";
import useLiveSamples from "../../common/hooks/useLiveSamples";
import MetricsPanel, { MetricSection } from "./MetricsPanel";

/**
 * What boring is doing right now, in the Outreach dashboard's report layout
 * (the Insights stat column and line chart): the verification queue, and
 * Outreach's rate limit when there is one, each over the last two minutes,
 * sampled every two seconds while the page is open.
 */

export interface LiveRateLimit {
  limit: number;
  remaining: number;
  /** Unix seconds when the window resets. */
  reset?: number | null;
}

const LiveVerificationsPanel: FC<{ inQueue: number; rateLimit?: LiveRateLimit | null }> = ({ inQueue, rateLimit }) => {
  const rate = rateLimit && rateLimit.limit > 0 ? rateLimit : null;
  const used = rate ? Math.max(0, rate.limit - rate.remaining) : 0;
  const samples = useLiveSamples({ inQueue, rateUsed: used });

  const sections: MetricSection[] = [
    {
      key: "queue",
      title: "Live verifications",
      stats: [{ key: "inQueue", label: "Emails in queue", value: inQueue.toLocaleString() }],
      series: [{ key: "inQueue", label: "Emails in queue", color: COLORS.chartEmailProspectsChecked }],
    },
    ...(rate
      ? [
          {
            key: "rate",
            title: "Outreach rate limit",
            stats: [
              { key: "used", label: `of ${rate.limit.toLocaleString()} calls used`, value: used.toLocaleString() },
              {
                key: "remaining",
                label: rate.reset
                  ? `left, resets ${new Date(rate.reset * 1000).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" })}`
                  : "left",
                value: rate.remaining.toLocaleString(),
              },
            ],
            series: [{ key: "rateUsed", label: "Calls used", color: COLORS.chartEmailQuestionable }],
          },
        ]
      : []),
  ];

  return <MetricsPanel sections={sections} data={samples} xTickFormatter={(v) => String(v)} />;
};

export default LiveVerificationsPanel;
